import React from "react";
import { Link } from "react-router-dom";
import { opgaverData, galleriSubpages } from "../data/siteData";

export default function Footer() {
  return (
    <footer className="relative bg-[#015e40] text-white border-t border-[#014c33] overflow-hidden text-left">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <img
          src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/241673922-115391607525088-7228905637875262507-n.jpg"
          alt=""
          className="w-full h-full object-cover opacity-35 mix-blend-overlay"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#015e40]/85 via-[#015e40]/90 to-[#015e40]/98" />
      </div>

      {/* Upper Footer */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
        {/* Column 1: Brand & Contact */}
        <div className="flex flex-col gap-6 items-start text-left">
          <div className="flex items-center justify-start">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=360,quality=90,format=auto/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/238887662-105023521895230-2092375161697519941-n.png"
              alt="Elmegaarden Logo"
              className="h-16 md:h-20 w-auto object-contain brightness-0 invert"
            />
          </div>
          <div className="flex flex-col gap-3 text-sm text-white/85 items-start text-left">
            <div className="flex items-center gap-3">
              <i className="fa-solid fa-location-dot text-[#7ca632] w-5 text-center" />
              <span>Stenstrupvej 5, 9500 Hobro</span>
            </div>
            <div className="flex items-center gap-3">
              <i className="fa-solid fa-phone text-[#7ca632] w-5 text-center" />
              <a href="tel:+4520661517" className="hover:text-[#7ca632] transition-colors whitespace-nowrap font-medium">
                20 66 15 17
              </a>
            </div>
            <div className="flex items-center gap-3">
              <i className="fa-solid fa-envelope text-[#7ca632] w-5 text-center" />
              <a
                href="mailto:rasmus@elmegaardenhaveoganlaeg.dk"
                className="hover:text-[#7ca632] transition-colors break-all"
              >
                rasmus@elmegaardenhaveoganlaeg.dk
              </a>
            </div>
            <div className="flex items-center gap-3">
              <i className="fa-solid fa-id-card text-[#7ca632] w-5 text-center" />
              <span>CVR: 42349127</span>
            </div>
          </div>
          <div className="pt-2">
            <a
              href="https://www.facebook.com/ElmegaardenHaveogAnlaeg"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-xs font-bold text-white hover:text-[#7ca632] transition-colors"
            >
              <i className="fa-brands fa-facebook-f text-sm" /> Følg os på Facebook
            </a>
          </div>
        </div>

        {/* Column 2: Opgaver */}
        <div className="flex flex-col gap-6">
          <h3 className="font-sans text-lg font-semibold text-white tracking-wider">
            Opgaver
          </h3>
          <nav className="flex flex-col gap-2.5 text-sm text-white/80">
            {opgaverData.map((opg) => (
              <Link
                key={opg.slug}
                to={`/opgaver/${opg.slug}`}
                className="hover:text-[#7ca632] transition-colors"
              >
                {opg.menuTitle}
              </Link>
            ))}
            <Link to="/andre-opgaver" className="hover:text-[#7ca632] transition-colors">
              Andre opgaver
            </Link>
            <Link to="/vi-tilbyder/autoriseret-kloakarbejde" className="hover:text-[#7ca632] transition-colors font-medium text-[#7ca632]">
              Autoriseret kloakmester
            </Link>
          </nav>
        </div>

        {/* Column 3: Galleri Subpages */}
        <div className="flex flex-col gap-6">
          <h3 className="font-sans text-lg font-semibold text-white tracking-wider">
            Gallerier
          </h3>
          <nav className="flex flex-col gap-2.5 text-sm text-white/80">
            {galleriSubpages.slice(0, 6).map((sub) => (
              <Link
                key={sub.slug}
                to={`/galleri/${sub.slug}`}
                className="hover:text-[#7ca632] transition-colors"
              >
                {sub.heading}
              </Link>
            ))}
            <Link to="/galleri" className="hover:text-[#7ca632] transition-colors font-medium">
              Se alle gallerier →
            </Link>
          </nav>
        </div>

        {/* Column 4: Quick links & Opening hours */}
        <div className="flex flex-col gap-6">
          <h3 className="font-sans text-lg font-semibold text-white tracking-wider">
            Information
          </h3>
          <div className="flex flex-col gap-2.5 text-sm text-white/80 mb-2">
            <Link to="/" className="hover:text-[#7ca632] transition-colors">
              Hjem
            </Link>
            <Link to="/om-os" className="hover:text-[#7ca632] transition-colors">
              Om os
            </Link>
            <Link to="/kontakt" className="hover:text-[#7ca632] transition-colors">
              Kontakt os
            </Link>
          </div>

          <div className="pt-4 border-t border-white/10 flex flex-col gap-2 text-xs text-white/70">
            <span className="font-bold text-white uppercase tracking-wider text-[11px]">Telefontid:</span>
            <div className="flex justify-between">
              <span>Mandag - Fredag:</span>
              <span className="text-white font-medium">07:00 - 17:00</span>
            </div>
            <div className="flex justify-between">
              <span>Lørdag - Søndag:</span>
              <span className="text-white/60">Efter aftale</span>
            </div>
          </div>
        </div>
      </div>

      {/* Lower Footer */}
      <div className="relative z-10 border-t border-[#014c33] py-8 bg-[#004f36]/90 backdrop-blur-xs">
        <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/60">
          <p>© {new Date().getFullYear()} Elmegaarden Have og Anlæg. CVR: 42349127.</p>
          <p>Anlægsgartner & autoriseret kloakmester i Hobro, Arden & Hadsund.</p>
        </div>
      </div>
    </footer>
  );
}
